import { useAuth } from "@/providers/AuthProvider";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import PaymentDashboard from "@/components/PaymentDashboard";
import PaymentLinkForm from "@/components/PaymentLinkForm";

import { useState } from "react";
export default function Index() {
  const {
    user
  } = useAuth();
  const navigate = useNavigate();
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const handleLinkGenerated = () => {
    // Increment the refresh trigger to cause the dashboard to refresh
    setRefreshTrigger(prev => prev + 1);
  };
  const isIOS = 'capacitor' in window && navigator.userAgent.includes('iPhone');
  return <div className={`container mx-auto px-4 ${isIOS ? 'pt-2 pb-4' : 'py-4'}`}>
      <div className="max-w-5xl mx-auto">
        <div className="text-center">
          {user?.user_metadata?.business_logo && <div className="mt-2 flex justify-center">
              <img src={user.user_metadata.business_logo} alt="Business Logo" className="h-16 object-contain" />
            </div>}
        </div>
        
        {user ? <div className="max-w-5xl mx-auto space-y-4 pt-0">
            <PaymentDashboard refreshTrigger={refreshTrigger} />
            <PaymentLinkForm onLinkGenerated={handleLinkGenerated} />
          </div> : <div className="text-center py-8">
            <p className="mb-4">Sign in to access the application features</p>
            <Button onClick={() => navigate("/auth")}>Sign In</Button>
          </div>}
      </div>
    </div>;
}
